<template>
  <div class="calc">
    <ShowInputItems />
  </div>
</template>

<script>
// @ is an alias to /src
import ShowInputItems from "@/components/ShowInputItems.vue";

export default {
  name: "Calc",
  components: {
    ShowInputItems
  }
};
</script>
